import { ApiError } from "@softmax/observatory-client/transport";
import type { Operation } from "./draft-model";

export function failureMessage({
  operation,
  error,
}: {
  operation: Operation;
  error: unknown;
}) {
  const message = error instanceof Error ? error.message : String(error);

  if (operation === "refresh")
    return `Changes saved. Refresh failed: ${message}`;

  if (error instanceof ApiError && error.status < 500 && error.status !== 408)
    return message;

  return `Could not confirm whether the change was saved. Retry uses the same request. ${message}`;
}

export function invalidDraftWrite({
  operation,
  error,
}: {
  readonly operation: Operation;
  readonly error: unknown;
}): boolean {
  return (
    (operation === "save" || operation === "publish") &&
    error instanceof ApiError &&
    (error.status === 400 || error.status === 422)
  );
}
